import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["TheUserDropdown"], {
    items: $setup.userItems,
    username: $setup.userStore.username,
    onLogout: $setup.userStore.logout
  }, null, 8 /* PROPS */, ["items", "username", "onLogout"]))
}